import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { listUsers, deleteUser } from "../../actions/userActions";
import "../Pagination/Pagination.css";
import Pagination from "../Pagination/Pagination";
import ConfirmationModal from "../utils/ConfirmationModal";

const ListCustomer = () => {
  const dispatch = useDispatch();
const [showModal, setShowModal] = useState(false);
const [userToDelete, setUserToDelete] = useState(null);
const [modalMessage, setModalMessage] = useState("");

  const [userListData, setUserList] = useState([]);
  const [perPage, setPerPage] = useState(30);
  const [page, setPage] = useState(1);
  const [searchKey, setSearchKey] = useState("");
  const [totalCount, setTotalCount] = useState(0);

  const userList = useSelector((state) => state.userList);
  const { loading, error, users } = userList;

  const catDelete = useSelector((state) => state.userDelete);

  const {
    loading: loadingDelete,
    error: errorDelete,
    success: successDelete,
  } = catDelete;

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []); // Empty dependency → runs only once on mount

  
  useEffect(() => {
    if (users?.users) {
      // Sort users by creation date (latest first)
      const sortedUsers = [...users.users].sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
      setUserList(sortedUsers);
      setTotalCount(users?.count);
    }
  }, [users]);

  useEffect(() => {
    let obj = {
      skip: (page - 1) * perPage,
      limit: page * perPage,
    };
    if (searchKey) {
      obj.phone = searchKey;
    }
    dispatch(listUsers(obj));
  }, [dispatch, successDelete, searchKey, page]);

  useEffect(() => {
    setUserList(users?.users);
    setTotalCount(users?.count);
  }, [users]);

 const deleteHandler = (user) => {
  if (user.balanceAmount > 0) {
    // Instead of alert, show modal with warning
    setModalMessage("Customer cannot be deleted! Please clear pending amount.");
    setUserToDelete(null); // no deletion
    setShowModal(true);
  } else {
    setModalMessage(`Are you sure you want to delete ${user.name}?`);
    setUserToDelete(user);
    setShowModal(true);
  }
};
const confirmDelete = () => {
  if (userToDelete) {
    dispatch(deleteUser(userToDelete._id));
  }
  setShowModal(false);
  setUserToDelete(null);
};

  const search = (value) => {
    setSearchKey(value);
    setPage(1);
  };

  return (
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div className="col-lg-12 col-sm-6 ">
          <div class="card">
            <div class="card-body">
              <div class="d-flex flex-wrap justify-content-between">
                <div className="  mr-auto p-2">
                  {" "}
                  <h4 className="card-title">Customer List </h4>
                </div>
                <div class="p-2">
                  <input
                    type="number"
                    className="form-control "
                    placeholder="Search By Phone Number"
                    onKeyDown={(e) => search(e.target.value)}
                  />
                </div>
                <div class="  p-2">
                  <Link to="/user/create">
                    {" "}
                    <button
                      type="button"
                      className="btn btn-primary btn-md btn-block  "
                    >
                      <i className=" ms-2 icon-plus menu-icon"></i>
                      Create
                    </button>
                  </Link>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Customer Name</th>
                      <th>Customer ID</th>
                      <th>Place</th>
                      <th> Phone</th>
                      <th> Balance</th>
                      <th>
                        <Pagination
                          page={page}
                          perPage={perPage}
                          setPage={setPage}
                          totalCount={totalCount}
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {userListData?.length > 0 ? (
                      userListData?.map((user, index) => (
                        <tr>
                          <td>{(page - 1) * perPage + index + 1}</td>
                          <td>
                            <Link to={`/user/${user?._id}`}>{user?.name}</Link>
                          </td>
                          <td>{user?.customerId}</td>
                          <td>{user?.address1.slice(0, 15)}</td>
                          <td>
                            {user?.phone}
                            {user?.phone1 ? ` / ${user.phone1}` : ""}
                          </td>
                          <td>
                            <strong>
                              ₹ {Number(user?.balanceAmount || 0).toFixed(2)}
                            </strong>
                          </td>
                          <td>
                            <div class="d-flex flex-wrap">
                              {/* <div class="p-2"> */}
                              {/* {' '} */}
                              <Link to={`/user/edit/${user?._id}`}>
                                <button
                                  type="button"
                                  class="btn btn-outline-dark btn-sm"
                                >
                                  Edit
                                </button>
                              </Link>
                              {/* </div> */}
                              <div class="p-2">
                                {" "}
                                <button
                                  type="button"
                                  class="btn btn-outline-danger btn-sm"
                                  onClick={() => deleteHandler(user)}
                                >
                                  Delete
                                </button>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6}>
                          Customer not found on this mobile number
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ConfirmationModal
  show={showModal}
  onHide={() => setShowModal(false)}
  onConfirm={confirmDelete}
  title="Confirm Delete"
  message={modalMessage}
/>

    </div>
  );
};

export default ListCustomer;
